<template>
    <path
        d="M13 14V13H10V10H13V12H15V14H14V16H12V18H10V15H12V14H13ZM18 18H14V16H16V14H18V18ZM0 0H8V8H0V0ZM2 2V6H6V2H2ZM10 0H18V8H10V0ZM12 2V6H16V2H12ZM0 10H8V18H0V10ZM2 12V16H6V12H2ZM15 10H18V12H15V10ZM3 3H5V5H3V3ZM3 13H5V15H3V13ZM13 3H15V5H13V3Z" />
</template>